import React from 'react';
import useTranslation from 'Hooks/useTranslation';
import Module from './Components/Module';
import useModules from './Hooks/useModules';
import { ModulesContainer, EmptyContainer } from './style';

export default function Lessons({ course }) {
  const { modules } = useModules(course?.id);
  const { t2 } = useTranslation('CourseDetails');

  if (modules?.length === 0) {
    return <EmptyContainer>{t2('NoLessons')}</EmptyContainer>;
  }

  return (
    <ModulesContainer>
      {modules &&
        modules?.map(module => (
          <Module
            key={module.name}
            title={module.name}
            lessons={module?.lessons || []}
            moduleId={module?.id}
            modules={modules}
            course={course}
          />
        ))}
    </ModulesContainer>
  );
}
